import type { ProductType } from "@component/assets/AbstractLeadForm/types";
import type { CommonOptions } from "bm-ui-kit";

export const PRODUCT_TYPES: CommonOptions<ProductType> = [
	{
		label: "Lakáshitel, CSOK, támogatások",
		value: "MORTGAGE",
	},
	{
		label: "Bankszámlák",
		value: "RETAIL_ACCOUNT",
	},
	{
		label: "Személyi hitel",
		value: "PERSONAL_LOAN",
	},
	{
		label: "Babaváró hitel",
		value: "BABY_LOAN",
	},
	{
		label: "Lakástakarék",
		value: "BUILDING_SOCIETY",
	},
	{
		label: "Nyugdíj megtakarítás",
		value: "PENSION",
	},
	{
		label: "Biztosítások",
		value: "SAVINGS_INSURANCE",
	},
	{
		label: "Megtakarítások",
		value: "SAVINGS_ACCOUNT",
	},
	{
		label: "Vállalati hitelek, faktoring",
		value: "SME_LOAN",
	},
	{
		label: "Vállalati bankszámlák",
		value: "SME_ACCOUNT",
	},
	{
		label: "Lízing",
		value: "LEASING",
	},
	{
		label: "Munkáshitel",
		value: "WORKER_LOAN",
	},
];
